import React, { FC, useState } from 'react';
import {
  DashboardContainer, DashboardContainerBody, DashboardContainerHeader, StyledTitle
} from '../MoaDashboard.styles';
import { DashboardFilter, TranslationMetrics } from '../../../services/dashboard/dashboard.types';
import BatchStatusDisplay from "../BatchStatusDisplay";
import EventTranslationStatusDrawer, { TranslationStatusTypes } from "./EventTranslationStatusDrawer";

interface TranslationsContainerProps {
  translations?: TranslationMetrics
  filter: DashboardFilter
  isLoading: boolean
}

const TranslationsContainer: FC<TranslationsContainerProps> = (
    {
      translations,
      filter,
      isLoading
    }
) => {
  const [openMenuTranslationsDrawer, setOpenMenuTranslationsDrawer] = useState(false);
  const [openFailedMenuTranslationsDrawer, setOpenFailedMenuTranslationsDrawer] = useState(false);
  const [openPromotionTranslationsDrawer, setOpenPromotionTranslationsDrawer] = useState(false)
  const [openFailedPromotionTranslationsDrawer, setOpenFailedPromotionTranslationsDrawer] = useState(false);
  const [openProductTranslationsDrawer, setOpenProductTranslationsDrawer] = useState(false);
  const [openFailedProductTranslationsDrawer, setOpenFailedProductTranslationsDrawer] = useState(false);
  const [openBundleTranslationsDrawer, setOpenBundleTranslationsDrawer] = useState(false);
  const [openFailedBundleTranslationsDrawer, setOpenFailedBundleTranslationsDrawer] = useState(false);

  const hasNoTranslations: boolean =
      translations?.menus.total === 0
      && translations?.promotions.total === 0
      && translations?.products.total === 0
      && translations?.bundles.total === 0;

  const drawers = () => {
    return (
        <>
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Menus}
              filter={filter}
              isOpen={openMenuTranslationsDrawer}
              close={() => setOpenMenuTranslationsDrawer(false)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Menus}
              failed={true}
              filter={filter}
              isOpen={openFailedMenuTranslationsDrawer}
              close={() => setOpenFailedMenuTranslationsDrawer(false)}
              openDetailsDrawer={() => setOpenMenuTranslationsDrawer(true)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Promotions}
              filter={filter}
              isOpen={openPromotionTranslationsDrawer}
              close={() => setOpenPromotionTranslationsDrawer(false)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Promotions}
              failed={true}
              filter={filter}
              isOpen={openFailedPromotionTranslationsDrawer}
              close={() => setOpenFailedPromotionTranslationsDrawer(false)}
              openDetailsDrawer={() => setOpenPromotionTranslationsDrawer(true)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Products}
              filter={filter}
              isOpen={openProductTranslationsDrawer}
              close={() => setOpenProductTranslationsDrawer(false)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Products}
              failed={true}
              filter={filter}
              isOpen={openFailedProductTranslationsDrawer}
              close={() => setOpenFailedProductTranslationsDrawer(false)}
              openDetailsDrawer={() => setOpenProductTranslationsDrawer(true)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Bundles}
              filter={filter}
              isOpen={openBundleTranslationsDrawer}
              close={() => setOpenBundleTranslationsDrawer(false)}
          />
          <EventTranslationStatusDrawer
              type={TranslationStatusTypes.Bundles}
              failed={true}
              filter={filter}
              isOpen={openFailedBundleTranslationsDrawer}
              close={() => setOpenFailedBundleTranslationsDrawer(false)}
              openDetailsDrawer={() => setOpenBundleTranslationsDrawer(true)}
          />
        </>
    )
  }

  return (
      <DashboardContainer>
        <DashboardContainerHeader>Translations</DashboardContainerHeader>
        <DashboardContainerBody style={{justifyContent: 'center'}}>
          {(isLoading || hasNoTranslations) &&
            <StyledTitle>No translations at this moment</StyledTitle>
          }
          <BatchStatusDisplay
              name={'Menus'}
              batchStatus={translations?.menus}
              openDetailsDrawer={() => setOpenMenuTranslationsDrawer(true)}
              openFailedDrawer={() => setOpenFailedMenuTranslationsDrawer(true)}
              isLoading={isLoading}
          />
          <BatchStatusDisplay
              name={'Promotions'}
              batchStatus={translations?.promotions}
              openDetailsDrawer={() => setOpenPromotionTranslationsDrawer(true)}
              openFailedDrawer={() => setOpenFailedPromotionTranslationsDrawer(true)}
              isLoading={isLoading}
          />
          <BatchStatusDisplay
              name={'Products'}
              batchStatus={translations?.products}
              openDetailsDrawer={() => setOpenProductTranslationsDrawer(true)}
              openFailedDrawer={() => setOpenFailedProductTranslationsDrawer(true)}
              isLoading={isLoading}
          />
          <BatchStatusDisplay
              name={'Bundles'}
              batchStatus={translations?.bundles}
              openDetailsDrawer={() => setOpenBundleTranslationsDrawer(true)}
              openFailedDrawer={() => setOpenFailedBundleTranslationsDrawer(true)}
              isLoading={isLoading}
          />
        </DashboardContainerBody>
        {drawers()}
      </DashboardContainer>
  );
};

export default TranslationsContainer;